import Alpine from "alpinejs";
import matchHeights from "@paintface_danny/alpine-match-heights";
import persist from "@alpinejs/persist";
import sliders from "./sliders";
import Render from "./render";
import collapse from "@alpinejs/collapse";

document.addEventListener("DOMContentLoaded", function () {
	window.Alpine = Alpine;
	Alpine.plugin(collapse);
	Alpine.plugin(matchHeights);
	Alpine.plugin(persist);
	Alpine.start();

	sliders();

	new Render();

	// Array.prototype.forEach.call(document.querySelectorAll("*"), (element) => {
	// 	element.style.outline = "1px solid #" + ((Math.random() * 0xffffff) << 0).toString(16);
	// });
});
